import settings from '@/settings'

const meusClientes = (headers, filtros) => {
  let url = `${settings.apetrusApi}/clientes/inscritos-em-vendedor/`
  if (filtros) {
    const keys = Object.keys(filtros).filter(k => filtros[k] !== undefined && filtros[k] !== null)
    for (let i = 0; i < keys.length; i++) {
      const key = encodeURI(keys[i])
      const val = encodeURIComponent(filtros[keys[i]])
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${key}=${val}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  meusClientes
}
